<script setup>
import CLink from "@/Components/CLink.vue"
import {usePage} from "@inertiajs/vue3"
import {computed} from "vue"

const page = usePage()
const props = defineProps({
    colorGroups: Object
})

const selectedColor = computed(() => page.props.selectedColor)

//@todo - remover essa funcao e formatar esse dado direto da ProductController
const capitalizeFirstLetter = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

const routeParamsClean = route().params
delete routeParamsClean.color
delete routeParamsClean.page
</script>

<template>
    <v-sheet class="pa-3">
        <v-sheet max-height="300" height="auto" class="mb-12">
            <p class="pb-2">Cores</p>
            <v-slide-group direction="vertical" prev-icon="mdi-chevron-up" next-icon="mdi-chevron-down">
                <v-slide-group-item v-for="color in colorGroups">
                    <c-link v-if="selectedColor === color.title" class="pa-2 bg-grey-lighten-4"
                            :href="route(route().current(), routeParamsClean)" preservestate>
                        <v-btn class="pa-0 mb-1 mr-2 border elevation-2" min-width="20px" height="20px" variant="flat" rounded
                               :title="capitalizeFirstLetter(color.title)" :color="color.hex"/>
                        {{ capitalizeFirstLetter(color.title) }}
                        <v-badge class="float-end mt-1" color="grey" icon="mdi-close" inline/>
                    </c-link>
                    <v-divider v-if="selectedColor === color.title"/>
                </v-slide-group-item>
                <v-slide-group-item v-for="color in colorGroups">
                    <c-link v-if="selectedColor !== color.title" class="pa-2"
                            :href="route(route().current(), {...routeParamsClean, color: color.title})" preservestate>
                        <v-btn class="pa-0 mb-1 mr-2 border elevation-2" min-width="20px" height="20px" variant="flat" rounded
                               :title="capitalizeFirstLetter(color.title)" :color="color.hex"/>
                        {{ capitalizeFirstLetter(color.title) }}
                    </c-link>
                    <v-divider/>
                </v-slide-group-item>
            </v-slide-group>
        </v-sheet>
    </v-sheet>
</template>
